import { render } from "./OrdenDetalleModal.vue?vue&type=template&id=03bdf718&scoped=true"
import script from "./OrdenDetalleModal.vue?vue&type=script&lang=js"
export * from "./OrdenDetalleModal.vue?vue&type=script&lang=js"

import "./OrdenDetalleModal.vue?vue&type=style&index=0&id=03bdf718&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03bdf718"]])

export default __exports__